export default "__VITE_ASSET__CPnr9j6M__"